// Action creators are currently all in same file. When there will be,
// alot more types, then maybe it would be wise to create seperate
// files for each entity (company, terminal etc.).

import {
  CREATE_ALLOWED_ROUTES,

  LOAD_COMPANIES_REQUEST, 
  LOAD_COMPANIES_SUCCESS, 
  LOAD_COMPANIES_FAILURE,
  DELETE_COMPANY_REQUEST,

  LOAD_TERMINALS_REQUEST, 
  LOAD_TERMINALS_SUCCESS, 
  LOAD_TERMINALS_FAILURE,
  DELETE_TERMINAL_FAILURE,
  DELETE_TERMINAL_SUCCESS,
  DELETE_TERMINALS_REQUEST,
  DELETE_TERMINAL_FAILURE_CLEAR,

  LOAD_PARTS_REQUEST, 
  LOAD_PARTS_SUCCESS, 
  LOAD_PARTS_FAILURE,
  DELETE_PART_FAILURE,
  DELETE_PART_SUCCESS,
  DELETE_PARTS_REQUEST,
  DELETE_PART_FAILURE_CLEAR,

  LOAD_USERS_REQUEST, 
  LOAD_USERS_SUCCESS, 
  LOAD_USERS_FAILURE,
  DELETE_USERS_REQUEST,

  LOAD_STATIONPUMPS_REQUEST, 
  LOAD_STATIONPUMPS_SUCCESS, 
  LOAD_STATIONPUMPS_FAILURE,
  STATIONS_DELETE_STATIONS,

  LOAD_OLDTERMINAL_REQUEST,
  LOAD_OLDTERMINAL_SUCCESS,
  LOAD_OLDTERMINAL_FAILURE,

  LOAD_NEWTERMINAL_REQUEST,
  LOAD_NEWTERMINAL_SUCCESS,
  LOAD_NEWTERMINAL_FAILURE,

  SUBMIT_TERMINALSWITCH_REQUEST,
  SUBMIT_TERMINALSWITCH_SUCCESS,
  SUBMIT_TERMINALSWITCH_FAILURE,
  GO_NEXT_TERMINALSWITCH_STEP,
  GO_TO_TERMINALSWITCH_STEP,
  GO_BACK_TERMINALSWITCH_STEP,
  RESET_TERMINALSWITCH,
  CHANGE_TERMINALSWITCH_MODE,

} from './actionTypes';

// General actions

export function createRoutes(allowedRoutesList) {
  return {
    type: CREATE_ALLOWED_ROUTES,
    payload: { allowedRoutesList }
  }
}


// GET ALL COMPANIES

export function loadCompaniesRequest() {
  return { 
    type: LOAD_COMPANIES_REQUEST,
  }
}

export function loadCompaniesSuccess(companies) {
  return { 
    type: LOAD_COMPANIES_SUCCESS,
    payload: { companies }
  }
}

export function loadCompaniesFailure() {
  return { 
    type: LOAD_COMPANIES_FAILURE,
  }
}

export function deleteCompaniesRequest() {
  return { 
    type: DELETE_COMPANY_REQUEST,
  }
}


// GET ALL TERMINALS

export function loadTerminalsRequest() {
  return { 
    type: LOAD_TERMINALS_REQUEST,
  }
}


export function loadTerminalsSuccess(terminals) {
  return { 
    type: LOAD_TERMINALS_SUCCESS,
    payload: { terminals }
  }
}

export function loadTerminalsFailure() {
  return { 
    type: LOAD_TERMINALS_FAILURE,
  }
}

export function deleteTerminalsRequest(data) {
  return { 
    type: DELETE_TERMINALS_REQUEST,
    data: data
  }
}

export function deleteTerminalsFailure() {
  return { 
    type: DELETE_TERMINAL_FAILURE
  }
}

export function deleteTerminalsSuccess() {
  return { 
    type: DELETE_TERMINAL_SUCCESS
  }
}

export function clearDeleteTerminalsFailure() {
  return { 
    type: DELETE_TERMINAL_FAILURE_CLEAR
  }
}

// GET ALL PARTS

export function loadPartsRequest() {
  return { 
    type: LOAD_PARTS_REQUEST,
  }
}


export function loadPartsSuccess(parts) {
  return { 
    type: LOAD_PARTS_SUCCESS,
    payload: { parts }
  }
}

export function loadPartsFailure() {
  return { 
    type: LOAD_PARTS_FAILURE,
  }
}

export function deletePartsRequest(data) {
  return { 
    type: DELETE_PARTS_REQUEST,
    data: data
  }
}

export function deletePartsFailure() {
  return { 
    type: DELETE_PART_FAILURE
  }
}

export function deletePartsSuccess() {
  return { 
    type: DELETE_PART_SUCCESS
  }
}

export function clearDeletePartsFailure() {
  return { 
    type: DELETE_PART_FAILURE_CLEAR
  }
}

// GET ALL USERS

export function loadUsersRequest() {
  return { 
    type: LOAD_USERS_REQUEST,
  }
}

export function loadUsersSuccess(users) {
  return { 
    type: LOAD_USERS_SUCCESS,
    payload: { users }
  }
}

export function loadUsersFailure() {
  return { 
    type: LOAD_USERS_FAILURE,
  }
}


export function deleteUsersRequest(data) {
  return { 
    type: DELETE_USERS_REQUEST,
    data: data
  }
}

// GET ALL COMPANIES

export function loadStationPumpsRequest() {
  return { 
    type: LOAD_STATIONPUMPS_REQUEST,
  }
}

export function loadStationPumpsSuccess(stationPumps) {
  return { 
    type: LOAD_STATIONPUMPS_SUCCESS,
    payload: { stationPumps }
  }
}

export function loadStationPumpsFailure() {
  return { 
    type: LOAD_STATIONPUMPS_FAILURE,
  }
}

export function deleteStationsRequest() {
  return { 
    type: STATIONS_DELETE_STATIONS
  }
}

// GET TERMINAL

export function loadTerminalRequest() {
  return { 
    type: LOAD_OLDTERMINAL_REQUEST,
  }
}

export function loadTerminalSuccess(terminal) {
  return { 
    type: LOAD_OLDTERMINAL_SUCCESS,
    payload: { terminal }
  }
}

export function loadTerminalFailure(errorText) {
  return { 
    type: LOAD_OLDTERMINAL_FAILURE,
    payload: errorText
  }
}

export function loadNewTerminalRequest() {
  return { 
    type: LOAD_NEWTERMINAL_REQUEST,
  }
}

export function loadNewTerminalSuccess(terminal) {
  return { 
    type: LOAD_NEWTERMINAL_SUCCESS,
    payload: { terminal }
  }
}

export function loadNewTerminalFailure(errorText) {
  return { 
    type: LOAD_NEWTERMINAL_FAILURE,
    payload: errorText
  }
}

export function submitTerminalSwitchRequest() {
  return { 
    type: SUBMIT_TERMINALSWITCH_REQUEST,
  }
}

export function submitTerminalSwitchSuccess() {
  return { 
    type: SUBMIT_TERMINALSWITCH_SUCCESS
  }
}

export function submitTerminalSwitchFailure(errorText) {
  return { 
    type: SUBMIT_TERMINALSWITCH_FAILURE,
    payload: errorText
  }
}

export function goNextTerminalSwitchStep(newStepState) {
  return { 
    type: GO_NEXT_TERMINALSWITCH_STEP,
    payload: newStepState
  }
}

export function goFirstTerminalSwitchStep(stepState) {
  return { 
    type: GO_NEXT_TERMINALSWITCH_STEP,
    payload: stepState
  }
}

export function resetTerminalSwitch() {
  return { 
    type: RESET_TERMINALSWITCH
  }
}

export function goBackTerminalSwitchStep(newStepState) {
  return { 
    type: GO_BACK_TERMINALSWITCH_STEP,
    payload: newStepState
  }
}

export function goToTerminalSwitchStep(newStepState) {
  return { 
    type: GO_TO_TERMINALSWITCH_STEP,
    payload: newStepState
  }
}

export function changeTerminalSwitchMode(newStepState) {
  return { 
    type: CHANGE_TERMINALSWITCH_MODE,
    payload: newStepState
  }
}


// WEBPACK FOOTER //
// ./src/actions/actionCreators.js